import Vue from 'vue';
import Storage from 'vue-ls';

Vue.use(Storage, {
  namespace: 'web-fe__',
});

export default Vue.ls;
